module.exports = __webpack_public_path__ + "media/images/emoticons/moon1-f9b95f9f0dc1378511f5d3d21a11fdc4.gif";